export default {
  modelSelector: {
    height: 'calc(80vh - 70px)',
    display: 'flex',
    flexDirection: 'column'
  },
  genericButton: {
    display: 'block',
    marginLeft: 'auto',
    fontSize: '1.4rem',
    lineHeight: '1.4rem',
    height: '3rem',
    borderRadius: '.5rem',
    '&[disabled]': { cursor: 'not-allowed' },
    '& svg': {
      marginRight: '.6rem',
      fontSize: '1.5rem'
    }
  },
  columnWrapper: {
    flex: '1 1 auto',
    minHeight: 0,
    display: 'flex'
  },
  alertEnter: {
    opacity: 0
  },
  alertEnterActive: {
    opacity: 1,
    transition: 'opacity 200ms'
  },
  alertExit: {
    opacity: 1
  },
  alertExitActive: {
    opacity: 0,
    transition: 'opacity 200ms'
  }
}



// WEBPACK FOOTER //
// ./src/components/DoorControllerModelSelector/style.js